import { Box, Tooltip, IconButton } from '@mui/material';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  row: any;
  handleEditContact?: (id: string) => void;
  handleDeleteRecord?: (id: string) => void;
  handlePreview?: (id: string) => void;
  handleRefresh?: (id: string) => void;
  isDelete?: boolean;
  isCampaignTamplate?: boolean;
  isEdit?: boolean;
  t: (key: string) => string;
};

// ----------------------------------------------------------------------

export function RowCellQuickActions({
  row,
  handleEditContact,
  handleDeleteRecord,
  handlePreview,
  handleRefresh,
  isDelete,
  isCampaignTamplate,
  isEdit,
  t,
}: Props) {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: 0.5,
        alignItems: 'center',
      }}
    >
      {/* 🔄 Refresh Button */}
      {handleRefresh && row.status !== 'APPROVED' && row.status !== 'approved' && (
        <Tooltip title={t('REFRESH') || 'Refresh'}>
          <IconButton color="info" onClick={() => 'id' in row && handleRefresh?.(row.id)}>
            <Iconify icon="mdi:refresh" />
          </IconButton>
        </Tooltip>
      )}

      {/* 👁 Preview Button */}
      {handlePreview && (
        <Tooltip title="Preview">
          <IconButton color="primary" onClick={() => 'id' in row && handlePreview?.(row.id)}>
            <Iconify icon="mdi:eye" />
          </IconButton>
        </Tooltip>
      )}

      {/* EDIT BTN */}
      {handleEditContact && isEdit && !isCampaignTamplate && (
        <Tooltip title={t('EDIT')}>
          <IconButton onClick={() => 'id' in row && handleEditContact?.(row.id)}>
            {'Settingname' in row ? (
              <Iconify icon="solar-settings-bold-duotone" />
            ) : (
              <Iconify icon="mdi:edit-outline" />
            )}
          </IconButton>
        </Tooltip>
      )}

      {/* DELETE BTN */}
      {isDelete && !isCampaignTamplate && (
        <Tooltip title={t('DELETE')}>
          <span>
            <IconButton color="error" onClick={() => 'id' in row && handleDeleteRecord?.(row.id)}>
              <Iconify
                icon="material-symbols-light:delete-outline"
                sx={{ color: 'var(--palette-error-main) !important' }}
              />
            </IconButton>
          </span>
        </Tooltip>
      )}
    </Box>
  );
}
